// @ts-nocheck
import { z } from 'zod';
import i18n, { ensureI18n } from '@/core/i18n/i18n';

const resources = {
  'en-US': {
    zod: {
      errors: {
        invalid_type: 'Field is required',
        invalid_type_received_null: 'Field is required',
        invalid_type_received_undefined: 'Required',
        invalid_literal: 'Invalid literal value, expected {{expected}}',
        unrecognized_keys: 'Unrecognized key(s) in object: {{- keys}}',
        invalid_union: 'Invalid input',
        invalid_union_discriminator: 'Invalid discriminator value. Expected {{- options}}',
        invalid_enum_value: 'Invalid enum value. Expected {{- options}}, received {{received}}',
        invalid_arguments: 'Invalid function arguments',
        invalid_return_type: 'Invalid function return type',
        invalid_date: 'Invalid date',
        custom: 'Invalid input',
        invalid_intersection_types: 'Intersection results could not be merged',
        not_multiple_of: 'Number must be a multiple of {{multipleOf}}',
        not_finite: 'Number must be finite',
        invalid_string: {
          email: 'Invalid {{validation}}',
          url: 'Invalid {{validation}}',
          uuid: 'Invalid {{validation}}',
          cuid: 'Invalid {{validation}}',
          regex: 'Invalid',
          datetime: 'Invalid {{validation}}',
          startsWith: 'Invalid input: must start with "{{startsWith}}"',
          endsWith: 'Invalid input: must end with "{{endsWith}}"',
        },
        too_small: {
          array: {
            exact: 'Array must contain exactly {{minimum}} element(s)',
            inclusive: 'Array must contain at least {{minimum}} element(s)',
            not_inclusive: 'Array must contain more than {{minimum}} element(s)',
          },
          string: {
            exact: 'Field must contain exactly {{minimum}} character(s)',
            inclusive: 'Field must contain at least {{minimum}} character(s)',
            not_inclusive: 'Field must contain over {{minimum}} character(s)',
          },
          number: {
            exact: 'Number must be exactly {{minimum}}',
            inclusive: 'Number must be greater than or equal to {{minimum}}',
            not_inclusive: 'Number must be greater than {{minimum}}',
          },
          set: {
            exact: 'Invalid input',
            inclusive: 'Invalid input',
            not_inclusive: 'Invalid input',
          },
          date: {
            exact: 'Date must be exactly {{- minimum, datetime}}',
            inclusive: 'Date must be greater than or equal to {{- minimum, datetime}}',
            not_inclusive: 'Date must be greater than {{- minimum, datetime}}',
          },
        },
        too_big: {
          array: {
            exact: 'List must contain exactly {{maximum}} element(s)',
            inclusive: 'List must contain at most {{maximum}} element(s)',
            not_inclusive: 'List must contain less than {{maximum}} element(s)',
          },
          string: {
            exact: 'Field must contain exactly {{maximum}} character(s)',
            inclusive: 'Field must contain at most {{maximum}} character(s)',
            not_inclusive: 'Field must contain under {{maximum}} character(s)',
          },
          number: {
            exact: 'Number must be exactly {{maximum}}',
            inclusive: 'Number must be less than or equal to {{maximum}}',
            not_inclusive: 'Number must be less than {{maximum}}',
          },
          set: {
            exact: 'Invalid input',
            inclusive: 'Invalid input',
            not_inclusive: 'Invalid input',
          },
          date: {
            exact: 'Date must be exactly {{- maximum, datetime}}',
            inclusive: 'Date must be smaller than or equal to {{- maximum, datetime}}',
            not_inclusive: 'Date must be smaller than {{- maximum, datetime}}',
          },
        },
        validations: {
          email: 'Email address',
          url: 'URL',
          uuid: 'UUID',
          cuid: 'CUID',
          regex: 'Regex',
          datetime: 'Date and time value',
        },
        types: {
          function: 'Function',
          number: 'Number',
          string: 'Text',
          nan: 'no number',
          integer: 'Integer',
          float: 'Float',
          boolean: 'Boolean',
          date: 'Date',
          bigint: 'BigInt',
          undefined: 'Undefined',
          symbol: 'Symbol',
          null: 'Null',
          array: 'List',
          object: 'Object',
          unknown: 'Unknown',
          promise: 'Promise',
          void: 'Void',
          never: 'Never',
          map: 'Map',
          set: 'Set',
        },
      },
    },
  },
  'de-DE': {
    zod: {
      errors: {
        invalid_type: 'Feld ist erforderlich',
        invalid_type_received_null: 'Feld ist erforderlich',
        invalid_type_received_undefined: 'Darf nicht leer sein',
        invalid_literal: 'Ungültiger Literalwert, {{expected}} erwartet',
        unrecognized_keys: 'Unbekannte Schlüssel im Objekt: {{- keys}}',
        invalid_union: 'Ungültige Eingabe',
        invalid_union_discriminator: 'Ungültiger Diskriminatorwert, {{- options}} erwartet',
        invalid_enum_value: 'Ungültiger Enum-Wert. {{- options}} erwartet, {{received}} erhalten',
        invalid_arguments: 'Ungültige Funktionsargumente',
        invalid_return_type: 'Ungültiger Funktionsrückgabewert',
        invalid_date: 'Ungültiges Datum',
        custom: 'Ungültige Eingabe',
        invalid_intersection_types: 'Schnittmengenergebnisse konnten nicht zusammengeführt werden',
        not_multiple_of: 'Zahl muss ein Vielfaches von {{multipleOf}} sein',
        not_finite: 'Zahl muss endlich sein',
        invalid_string: {
          email: 'Ungültige {{validation}}',
          url: 'Ungültige {{validation}}',
          uuid: 'Ungültige {{validation}}',
          cuid: 'Ungültige {{validation}}',
          regex: 'Ungültig',
          datetime: 'Ungültiger {{validation}}',
          startsWith: 'Ungültige Eingabe: muss mit "{{startsWith}}" beginnen',
          endsWith: 'Ungültige Eingabe: muss mit "{{endsWith}}" enden',
        },
        too_small: {
          array: {
            exact: 'Liste muss genau {{minimum}} Element(e) enthalten',
            inclusive: 'Liste muss mindestens {{minimum}} Element(e) enthalten',
            not_inclusive: 'Liste muss mehr als {{minimum}} Element(e) enthalten',
          },
          string: {
            exact: 'Feld muss genau {{minimum}} Zeichen enthalten',
            inclusive: 'Feld muss mindestens {{minimum}} Zeichen enthalten',
            not_inclusive: 'Feld muss mehr als {{minimum}} Zeichen enthalten',
          },
          number: {
            exact: 'Zahl muss genau {{minimum}} sein',
            inclusive: 'Zahl muss größer oder gleich {{minimum}} sein',
            not_inclusive: 'Zahl muss größer als {{minimum}} sein',
          },
          set: {
            exact: 'Ungültige Eingabe',
            inclusive: 'Ungültige Eingabe',
            not_inclusive: 'Ungültige Eingabe',
          },
          date: {
            exact: 'Datum muss genau {{- minimum, datetime}} sein',
            inclusive: 'Datum muss größer oder gleich {{- minimum, datetime}} sein',
            not_inclusive: 'Datum muss größer als {{- minimum, datetime}} sein',
          },
        },
        too_big: {
          array: {
            exact: 'Array muss genau {{maximum}} Element(e) enthalten',
            inclusive: 'Array darf höchstens {{maximum}} Element(e) enthalten',
            not_inclusive: 'Array muss weniger als {{maximum}} Element(e) enthalten',
          },
          string: {
            exact: 'Feld muss genau {{maximum}} Zeichen enthalten',
            inclusive: 'Feld darf höchstens {{maximum}} Zeichen enthalten',
            not_inclusive: 'Feld muss weniger als {{maximum}} Zeichen enthalten',
          },
          number: {
            exact: 'Zahl muss genau {{maximum}} sein',
            inclusive: 'Zahl muss kleiner oder gleich {{maximum}} sein',
            not_inclusive: 'Zahl muss kleiner als {{maximum}} sein',
          },
          set: {
            exact: 'Ungültige Eingabe',
            inclusive: 'Ungültige Eingabe',
            not_inclusive: 'Ungültige Eingabe',
          },
          date: {
            exact: 'Datum muss genau {{- maximum, datetime}} sein',
            inclusive: 'Datum muss kleiner oder gleich {{- maximum, datetime}} sein',
            not_inclusive: 'Datum muss kleiner als {{- maximum, datetime}} sein',
          },
        },
        validations: {
          email: 'E-Mail-Adresse',
          url: 'URL',
          uuid: 'UUID',
          cuid: 'CUID',
          regex: 'Regex',
          datetime: 'Datums- und Uhrzeitwert',
        },
        types: {
          function: 'Funktion',
          number: 'Zahl',
          string: 'Text',
          nan: 'Keine Zahl',
          integer: 'Ganzzahl',
          float: 'Gleitkommazahl',
          boolean: 'Boolean',
          date: 'Datum',
          bigint: 'Bigint',
          undefined: 'Undefined',
          symbol: 'Symbol',
          null: 'Nullwert',
          array: 'Liste',
          object: 'Objekt',
          unknown: 'Unknown',
          promise: 'Promise',
          void: 'Void',
          never: 'Never',
          map: 'Map',
          set: 'Set',
        },
      },
    },
  },
} as const;

ensureI18n();
Object.entries(resources).forEach(([lng, resource]) => {
  if (!i18n.hasResourceBundle(lng, 'zod')) {
    i18n.addResourceBundle(lng, 'zod', resource.zod, true, true);
  }
});

const getTranslator = () => i18n.getFixedT(i18n.language ?? 'de-DE', 'zod');

const sizeKey = (issue: { exact?: boolean; inclusive?: boolean }) =>
  issue.exact ? 'exact' : issue.inclusive ? 'inclusive' : 'not_inclusive';

type ErrorMapParams = Parameters<z.ZodErrorMap>;
const errorMap: z.ZodErrorMap = (issue: ErrorMapParams[0], ctx?: ErrorMapParams[1]) => {
  const t = getTranslator();
  const defaultValue = ctx?.defaultError ?? issue.message ?? 'Invalid input';
  const translate = (key: string, values?: Record<string, unknown>) =>
    t(key, {
      defaultValue,
      ...values,
    });

  switch (issue.code) {
    case 'invalid_type':
      if (issue.received === 'undefined') {
        return { message: translate('errors.invalid_type_received_undefined') };
      }
      if (issue.received === 'null') {
        return { message: translate('errors.invalid_type_received_null') };
      }
      return {
        message: translate('errors.invalid_type', {
          expected: t(`types.${issue.expected}`, { defaultValue: issue.expected }),
          received: t(`types.${issue.received}`, { defaultValue: issue.received }),
        }),
      };
    case 'invalid_literal':
      return {
        message: translate('errors.invalid_literal', {
          expected: JSON.stringify(issue.expected),
        }),
      };
    case 'unrecognized_keys':
      return {
        message: translate('errors.unrecognized_keys', {
          keys: issue.keys.join(', '),
          count: issue.keys.length,
        }),
      };
    case 'invalid_union':
      return { message: translate('errors.invalid_union') };
    case 'invalid_union_discriminator':
      return {
        message: translate('errors.invalid_union_discriminator', {
          options: issue.options.join(', '),
        }),
      };
    case 'invalid_enum_value':
      return {
        message: translate('errors.invalid_enum_value', {
          options: issue.options.join(', '),
          received: issue.received,
        }),
      };
    case 'invalid_arguments':
      return { message: translate('errors.invalid_arguments') };
    case 'invalid_return_type':
      return { message: translate('errors.invalid_return_type') };
    case 'invalid_date':
      return { message: translate('errors.invalid_date') };
    case 'invalid_string':
      if (typeof issue.validation === 'object') {
        if ('startsWith' in issue.validation) {
          return {
            message: translate('errors.invalid_string.startsWith', {
              startsWith: issue.validation.startsWith,
            }),
          };
        }
        if ('endsWith' in issue.validation) {
          return {
            message: translate('errors.invalid_string.endsWith', {
              endsWith: issue.validation.endsWith,
            }),
          };
        }
      }
      return {
        message: translate(`errors.invalid_string.${issue.validation ?? 'regex'}`, {
          validation: issue.validation,
        }),
      };
    case 'too_small':
      return {
        message: translate(`errors.too_small.${issue.type}.${sizeKey(issue)}`, {
          minimum: issue.minimum,
        }),
      };
    case 'too_big':
      return {
        message: translate(`errors.too_big.${issue.type}.${sizeKey(issue)}`, {
          maximum: issue.maximum,
        }),
      };
    case 'custom': {
      const customKey =
        typeof issue.params?.i18n === 'string' ? issue.params.i18n : 'errors.custom';
      return { message: translate(customKey, issue.params?.values as Record<string, unknown>) };
    }
    case 'not_multiple_of':
      return {
        message: translate('errors.not_multiple_of', {
          multipleOf: issue.multipleOf,
        }),
      };
    case 'not_finite':
      return { message: translate('errors.not_finite') };
    default:
      return { message: defaultValue };
  }
};

z.setErrorMap(errorMap);

export default z;
